import {AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationModule} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    imports: [
        PaginationModule,
        FormsModule,
        NgFor
    ]
})

/**
 * @class
 * @description this component is for common use of pagination. The main purpose was to provide a reuseable component
 * for the team to use with common styling and the functionality to change the number of items per page. Example usage
 * can be found in customer-approval-list.component and customer-approval-list.html. As well as more documentation in
 * the team drive.
 */
export class PaginationComponent implements OnInit, AfterViewChecked {
  constructor(private cdref: ChangeDetectorRef) {
  }

  /**
   * @description class property (value of current page)
   */
  _currentPage = 1;

  /**
   * @description input binding for the current page allow child component to to change the value of the current page
   * @returns number
   */
  @Input()
  get currentPage(): number {
    return this._currentPage;
  }

  /**
   * @description output binding for the current page allow child component to see change to current page
   */
  @Output() currentPageChange = new EventEmitter<number>();

  /**
   * @description setter for current page property. emits an event when current page changes
   * @param page (the number of the current page)
   */
  set currentPage(page: number) {
    this._currentPage = page;
    this.currentPageChange.emit(this._currentPage);
  }

  /**
   * @description class property (value of number of items per page)
   */
  _itemsPerPage = 10;

  /**
   * @description class property (list of option to choose in dropdown)
   */
  itemsPerPageList = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

  /**
   * @description input binding for items per page allows child component to change the value of items per page
   * @returns number
   */
  @Input()
  get itemsPerPage(): number {
    return this._itemsPerPage;
  }

  /**
   * @description output binding for items per page allows child component to see change to the number of items per page
   */
  @Output() itemsPerPageChange = new EventEmitter<number>();

  /**
   * @description setter for items per page property. emits an event when items per page changes
   * @param items (the number of items per page)
   */
  set itemsPerPage(items: number) {
    this._itemsPerPage = items;
    this.itemsPerPageChange.emit(this._itemsPerPage);
  }

  /**
   * @description class property (value of total items in pagination)
   */
  _totalItems = 0;

  /**
   * @description input binding for the total items allows child component to change the value of total items
   * @returns number
   */
  @Input()
  get totalItems(): number {
    return this._totalItems;
  }

  /**
   * @description output binding for total items allows child component to see change to total items
   */
  @Output() totalItemsChange = new EventEmitter<number>();

  /**
   * @description setter for total items property. emits an event when items total items changes
   * @param page (the number of the current page)
   */
  set totalItems(items: number) {
    this._totalItems = items;
    this.totalItemsChange.emit(this._totalItems);
  }

  /**
   * @description changes the page
   * @param page (the number of the page to change to)
   */
  page(page: number) {
    this._currentPage = page;
    this.currentPageChange.emit(this._currentPage);
  }


  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }
}
